module.exports = __webpack_public_path__ + "static/media/instagram.c3f7e0fa.svg";